import { AbstractGameService } from '../../core/abstraction/AbstractGameService';
import {
  getBonusSpinUrl,
  getBuyBonusUrl,
  getInitialStateUrl,
  getPreBonusSpinUrl,
  getSpinUrl,
} from '../../core/endponts';
import { httpClient } from '../../core/httpClient';

export class RealGameStrategy extends AbstractGameService {
  async spin(body) {
    return await httpClient.post(getSpinUrl(), body).then(res => {
        return {
          ...res,
          result: res.result.resultCrystal,
        };
      },
    );
  }

  async bonusSpin(body) {
    return await httpClient.post(getBonusSpinUrl(), body);
  }

  async preBonusSpin(body) {
    return await httpClient.post(getPreBonusSpinUrl(), body);
  }

  async buyBonus(body) {
    return await httpClient.post(getBuyBonusUrl(), body);
  }

  async getInitialState(params) {
    return await httpClient.get(getInitialStateUrl(), {
      credentials: 'include',
      params,
    });
  }
}
